import React, { FunctionComponent, ReactElement, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import VariantSelectorItem from './VariantSelectorItem';
import { CustomiseSections } from '../../../enum/CustomiseSections';
import { customiseActions } from '../../../../customise/store/reducers/customiseReducer';
import specPackDataLayerRest from '../../../utils/dataLayer/rest/SpecPackDataLayerRest';
import useWidgetContext from '../../../react/useWidgetContext';

export interface IVariantSelectorItemContainerProps {
  modelName: string;
  variantName: string;
  variantShortName: string;
  selected: boolean;
  selectVariantId: (variantId: string) => void;
  id: string;
  detailsSlot: ReactElement;
}

const VariantSelectorItemContainer: FunctionComponent<IVariantSelectorItemContainerProps> = ({
  modelName,
  variantName,
  variantShortName,
  selected,
  selectVariantId,
  id,
  detailsSlot,
}) => {
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch();
  const {
    configuration: { dimensions },
  } = useWidgetContext();

  useEffect(() => {
    setExpanded(selected);
  }, [selected]);

  const selectVariantTab = useCallback(
    (isSelected: boolean) => {
      dispatch(customiseActions.setSelectedSection(CustomiseSections.VARIANT));
      specPackDataLayerRest(variantShortName, dimensions);
      if (!isSelected) {
        return setExpanded(false);
      }

      setExpanded(true);

      if (!selected) {
        selectVariantId(id);
      }
    },
    [setExpanded, id, selectVariantId, selected],
  );

  return (
    <VariantSelectorItem
      expanded={expanded}
      selected={selected}
      selectVariantTab={selectVariantTab}
      modelName={modelName}
      variantName={variantName}
      detailsSlot={detailsSlot}
    />
  );
};

export default VariantSelectorItemContainer;
